/**
 * Created by Julio Perez on 12/19/2016.
 */
import _ from 'underscore';

class MapTopCountriesService {
    constructor(){

        let vm = this;

        vm.currentMax= 0;
        vm.historicMax= 0;
        vm.forecastMax= 0;
        vm.countrySegment = null;
        vm.sectionSelected = null
        vm.toggleSelected = "Current";
        vm.segmentLabels = {};
        vm.latlngData = require('./data/country-latlng.json');
        vm.segmentedCountries = require('./data/map-countries-litres-percent-wine-T25.json');

        vm.getValue=(value)=>{
            console.log("-------- ", vm.sectionSelected, vm.toggleSelected, value);
            let newValue = value;
            if(vm.sectionSelected.toLowerCase() != "total wine"){
                newValue = value * 100;
            }

            return newValue;

        }

        vm.getCountryLatLng=()=>{
            let countryLatLng = vm.latlngData
                .map(function(item){
                    return{
                        country: item.country,
                        latlng: item.latlng
                    }
                });

            return countryLatLng;
        }


        vm.getCountrySegment=(seg)=>{

            vm.countrySegment= vm.segmentedCountries
                .filter(function(item){
                    return item.segment === seg;
                })
                .map(function(item){
                    return item.metrics
                        .map(function(metric){
                            return {
                                "metricValueCurrent": vm.getValue(metric.metricValueCurrent),
                                "metricValueForecast": vm.getValue(metric.metricValueForecast),
                                "latlng": metric.latlng,
                                "country": metric.country
                            }
                        })
                }).shift();

            return vm.countrySegment.concat();
        }

        vm.getSegmentLabels=(seg)=>{

            vm.segmentLabels = vm.segmentedCountries
                .filter(function(item){
                    return item.segment === seg;
                })
                .map(function(item){
                    return {
                        "segment": item.segment,
                        "unit": item.unit,
                        "historic": item.historic_year,
                        "current": item.current_year,
                        "forecast": item.forecast_year
                        }
                }).shift();

            return vm.segmentLabels;

        }

        vm.getCurrentMax=(seg)=>{

            vm.currentMax= vm.segmentedCountries
                .filter(function(item){
                    return item.segment === seg;
                })
                .map(function(item){
                    return item.current_max;
                }).shift();

            return vm.currentMax;
        }

        vm.getHistoricMax=(seg)=>{

            vm.historicMax = vm.segmentedCountries
                .filter(function(item){
                    return item.segment === seg;
                })
                .map(function(item){
                    return item.historic_max;
                }).shift();

            return vm.historicMax;
        }


        vm.getForecastMax=(seg)=>{

            vm.forecastMax = vm.segmentedCountries
                .filter(function(item){
                    return item.segment === seg;
                })
                .map(function(item){
                    return item.forecast_max;
                }).shift();

            return vm.forecastMax;
        }


    }


}

export default angular
    .module('map-top-countries.service', [])
    .service('mapTopCountriesService', MapTopCountriesService)
    .name;


// WEBPACK FOOTER //
// ./src/app/services/map-top-countries.service.js